import { companyService } from '../../helpers/services/company.service';
import { sharedHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const COMPANY_MODULE = 'company';

// define action 
export const GET_ALL_COMPANIES = 'getAllCompanies';

// define mutation
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_COMPANIES_REQUEST = "getAllCompanies";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_COMPANIES]({ commit }, { filter }) {
        await companyService
            .getAllCompanies(filter)
            .then(
                (result) => {
                    commit(GET_ALL_COMPANIES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Company-listing" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { processing: true, update: true, create: true };
    },
    [GET_ALL_COMPANIES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {

            return {
                id: o.id,
                name: o.name,
                address: o.address,
                postcode: o.postcode,
                phone: o.phone,
                email: o.email,
                url: o.url,
                image: o.image,
                state: o.state,
                isCompany: o.is_company,
                isListed: o.is_listed,
                parentGroup: o.parent_group,
                colour: o.colour,
                banner: o.banner,
                companyUser: o.company_user,
                companyIhextarUser: o.company_ihextar_users,
                activeCompanyIhextarUser: o.active_company_ihextar_users,
            }
        })
    }
}


